import {AxiosResponse} from "axios";
import type {TRootState} from "types";

// The error ensureOk throws. `code` is the machine code from the RFC 7807
// problem body (e.g. "footprint_generating"); `status` is the HTTP status
// (absent on a network failure). createAsyncThunk keeps `code` (but not
// `status`) when it serialises the error into `action.error`.
export type TPolarisApiError = Error & {code?: string; status?: number};

// HttpClient resolves failed calls with the error response (or undefined on
// network failure) instead of throwing — normalise that here.
export const ensureOk = <T>(response: AxiosResponse<T> | undefined, fallbackMessage: string): T => {
	if (!response || response.status >= 400) {
		const body = response?.data as {detail?: string; code?: unknown} | null | undefined;
		const error: TPolarisApiError = new Error(body?.detail || fallbackMessage);

		if (typeof body?.code === "string") error.code = body.code;
		if (response) error.status = response.status;

		throw error;
	}

	return response.data;
};

// The machine code carried by a thrown TPolarisApiError or a rejected thunk's
// serialised `action.error`; undefined for anything else.
export const errorCodeOf = (error: unknown): string | undefined => {
	const code = (error as {code?: unknown} | null | undefined)?.code;

	return typeof code === "string" ? code : undefined;
};

export const searchIdOf = (getState: () => unknown): string => {
	const id = (getState() as TRootState).polaris.search_id;

	if (!id) throw new Error("No active Polaris search");

	return id;
};
